import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpResponseBase
} from "@angular/common/http";
import { map } from "rxjs/operators";

import * as FileSaver from "file-saver";
import * as XLS from "xlsx";
import * as XLSX from "xlsx";
import { environment } from "src/environments/environment";
import { AuthService } from "./auth.service";
import { CiCdConfigService } from "src/cicd/ci-cd-config.service";

const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xls";

@Injectable({
  providedIn: "root"
})
export class DescargarArchivosService {
  public headers: HttpHeaders;
  public urlApi: string;
  public userId: any = { documento: 0, tipo_documento: '' };
  public userData: any;

  constructor(private http: HttpClient, 
    private auth: AuthService,
    private readonly ciCd: CiCdConfigService
  ) {
    // this.urlApi = environment.urlApi; // PREJENKINS
    this.ciCdInit();
    this.headers = new HttpHeaders();
    this.headers.append("Content-Type", "multipart/form-data");
    this.headers.append("Accept", "application/x-www-form-urlencoded");
    this.initializeHeaders();
  }

  ciCdInit() {
    this.ciCd.loadConfigurations().subscribe(({ apis }: any) => {
      const { urlApi } = apis;
      this.urlApi = urlApi;
    });
  }

  initializeHeaders() {
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
  }

  downloadManagementReport(contract: string) {
    this.headers.append("Content-Type", "multipart/form-data");
    this.headers.append("Accept", "application/x-www-form-urlencoded");
    this.headers = this.headers.set("token", localStorage.getItem("tokenCVE"));

    const headers = this.headers;
    const options = { headers };
    return this.http.get(
      `${this.urlApi}/pr_exportar_informe_gestion?contrato=${contract}`,
      {
        headers: options.headers,
        responseType: "blob"
      }
    );
  }

    downloadPaymentsReport() {
      this.userId = this.auth.getDocument();
      this.headers.append("Content-Type", "multipart/form-data");
      this.headers.append("Accept", "application/x-www-form-urlencoded");
      this.headers = this.headers.set("token", localStorage.getItem("tokenCVE"));
      const headers = this.headers;

      const params = { ...this.userId, };
      let options = { params, headers };

      return this.http.get(
        `${this.urlApi}/pr_get_payments_file`,
        {
          headers: options.headers,
          responseType: "blob",
          params: options.params
        }
      );
  }
}
